<template>
    <div class="upload-item">
        <div class="upload-file-icon">
            <wps-icon :type="ext"/>
        </div>
        <div class="upload-file-info">
            <div class="upload-file-name nowrap">
                <span v-text="data.fname.length > 50 ? (data.fname.slice(0,50) + '...') : data.fname" :title="data.fname"></span>
            </div>
            <div class="upload-file-size nowrap">{{size}}</div>
        </div>
        <div class="upload-file-action">
            <span class="upload-cancel" @click="cancelFile(data)" v-if="data.uploading">{{$t('Cancel')}}</span>
            <div class="upload-faction-success nowrap" v-if="!data.uploading && !data.failed" @click="open">
                <span class="upload-openfolder" :title="$t('Openfolder')">{{$t('Openfolder')}}</span>
            </div>
            <div v-if="data.result" class="upload-faction-fail nowrap" :title="$t(data.result)">{{$t(data.result)}} </div>
        </div>
        <div :class="`upload-file-status ${data.uploading ? 'item-uploading' : ''}`">
            <i v-if="!data.uploading && !data.failed" class="components-icons components-icons-success"><span class="path1"></span></i>
            <i v-if="data.failed" class="components-icons components-icons-warning"><span class="path1"></span></i>
            <div v-if="data.uploading" class="upload-loading">
                <div class="upload-loading-left">
                    <div class="loading-progress" :style="{transform: `rotate(${left}deg)`}"></div>
                </div>
                <div class="upload-loading-right">
                    <div class="loading-progress" :style="{transform: `rotate(${right}deg)`}"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    props: ['data','cancelFile'],
    computed:{
        ...mapState([
            'route'
        ]),
        size(){
            let size = this.data.size
            return size > 1073741824 ? 
                `${(size/1073741824).toFixed(2)}GB` : 
                size > 1048576 ? `${(size/1048576).toFixed(2)}MB` : 
                size > 1024 ? `${(size/1024).toFixed(2)}KB` : `${size}B`
        },
        ext(){
            let name = this.data.fname 
            return name.slice(name.lastIndexOf('.')+1)
        },
        name(){
            return this.data.fname.replace(`.${this.ext}`,'')
        },
        right(){
            return this.data.percent > 50 ? 180 : this.data.percent * 3.6
        },
        left(){
            return this.data.percent > 50 ? 180 + (this.data.percent - 50) * 3.6 : 180
        }
    },
    methods:{
        open(){
            let jumpUrl
            if (this.route == 'teams') {
                let {groupid,parentid} = this.data
                jumpUrl = this.data.parentid ? `/team/${groupid}/${parentid}` : `/team/${groupid}`
            }else{
                jumpUrl =  this.data.parentid ? `/mine/${this.data.parentid}` : '/'
            }
            this.$router.push(jumpUrl)
        }
    }
}
</script>

<style>
.upload-item{
    height: 67px;
    border-bottom: 1px solid #eee;
    display: flex;
    min-width: 0;
    align-items: center;
}
.upload-file-info{
    flex: 0 0 142px;
    min-width: 0;
}
.upload-file-icon{
    font-size: 30px;
    width: 30px;
    margin-right: 20px;
}
.upload-file-name{
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #3c414b;
}
.upload-file-size{
    text-align: left;
    font-size: 12px;
    color: #949aae;
    line-height: 10px;
    margin-bottom: 8px;
}
.upload-file-action{
    width: 150px;
    flex: 0 0 150px;
    padding-right: 20px;
    text-align: right;
    height: 67px;
    line-height: 67px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-left: 10px;
    color: #626b84;
    font-size: 13px;
    text-align: right;
}
.upload-openfolder{
    cursor: pointer;
    display: none;
}
.upload-faction-fail{
    color: #e0686a;
}
.upload-file-status{
    width: 20px;
    font-size: 16px;
}
.upload-item:hover .upload-openfolder{
    display: inline-block;
}
.upload-file-status .components-icons-warning{
    color: #e97663;
}
.upload-loading{
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    background-color: #f1f4f7;
}
.upload-loading-left,.upload-loading-right{
    width: 50%;
    height: 100%;
    position: absolute;
    overflow: hidden;
}
.upload-loading-left{
    left: 0;
}
.upload-loading-right{
    right: 0;
}
.upload-loading-left .loading-progress{
    left: 0;
    transform: rotate(180deg);
}
.upload-loading-right .loading-progress{
    right: 0;
    
}
.loading-progress{
    position: absolute;
    top: 0;
    width: 16px;
    height: 16px;
    background: linear-gradient(90deg,#2e68f8,#2e68f8 50%,transparent 0,transparent);
    border-radius: 50%;
}
.upload-cancel{
    cursor: pointer;
    color: #2e68f8;
}
</style>


// WEBPACK FOOTER //
// src/components/fileitem/Upload.vue